export function schema_vision() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			"check": {
				"title": "Appliquer l'ocr qui si le pdf ne contient pas de texte (plus de 10 ou X caratères fois le nombre de pages)",
				"type": ["boolean", "number"],
				"default": true
			}
		},
	};
}
